// src/components/legal/TermsContent.tsx
import { COMPANY_INFO } from "@/config/constants";

export function TermsContent() {
  return (
    <div className="space-y-5">
      <p>
        Estes Termos de Uso regulam o acesso e uso do site e serviços
        <strong> LDA — Libertação das Apostas</strong>, operados por
        <strong> 53.820.194 MARLON GUSTAVO DA SILVA RIBEIRO</strong> (CNPJ 53.820.194/0001-38).
        Ao utilizar o site, você concorda integralmente com estes Termos.
      </p>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">1. Serviços</h4>
        <p>
          Oferecemos conteúdos educacionais, programas, trilhas e mentorias com
          foco em mudança de comportamento em relação a jogos de azar. Não
          prestamos atendimento médico, psicológico ou financeiro. Os materiais
          são informativos e de apoio ao desenvolvimento pessoal.
        </p>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">2. Conta e Acesso</h4>
        <ul className="list-disc space-y-1 pl-5">
          <li>Você deve fornecer dados verdadeiros e manter suas credenciais em sigilo.</li>
          <li>Podemos suspender contas em caso de uso indevido ou violação destes Termos.</li>
        </ul>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">3. Pagamentos, Garantia e Cancelamentos</h4>
        <ul className="list-disc space-y-1 pl-5">
          <li>Compras são processadas por plataformas parceiras (checkout seguro).</li>
          <li>Salvo indicação em contrário, oferecemos <strong>garantia incondicional de 7 dias</strong> a partir da confirmação do acesso.</li>
          <li>Após esse prazo, não há reembolso, exceto por determinação legal.</li>
        </ul>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">4. Propriedade Intelectual</h4>
        <p>
          Todo o conteúdo (textos, vídeos, marcas, logotipos, layouts) é de
          titularidade da LDA/53.820.194 MARLON GUSTAVO DA SILVA RIBEIRO ou licenciado. É vedada a reprodução,
          distribuição, revenda, gravação ou compartilhamento sem autorização
          expressa, inclusive o acesso simultâneo por terceiros.
        </p>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">5. Conduta do Usuário</h4>
        <ul className="list-disc space-y-1 pl-5">
          <li>Não publicar, enviar ou propagar conteúdo ilegal, ofensivo ou que viole direitos de terceiros.</li>
          <li>Não tentar burlar sistemas, realizar engenharia reversa ou acesso não autorizado.</li>
          <li>Respeitar normas de convivência em comunidades e grupos vinculados.</li>
        </ul>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">6. Isenções e Limitação de Responsabilidade</h4>
        <p>
          Resultados podem variar conforme histórico individual, adesão às
          práticas e outros fatores. Os serviços <strong>não substituem</strong> diagnóstico,
          tratamento ou aconselhamento profissional. Na extensão permitida em
          lei, não nos responsabilizamos por danos indiretos, lucros cessantes
          ou perda de dados decorrentes do uso dos serviços.
        </p>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">7. Privacidade e Dados</h4>
        <p>
          Tratamos dados pessoais conforme nossa Política de Privacidade (LGPD).
          Ao usar o site, você consente com esse tratamento e com o uso de
          cookies, quando aplicável.
        </p>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">8. Alterações</h4>
        <p>
          Podemos atualizar estes Termos a qualquer momento. A versão vigente
          será sempre a mais recente publicada no site.
        </p>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">9. Lei Aplicável e Foro</h4>
        <p>
          Aplica-se a legislação brasileira. Fica eleito o foro da comarca de
          domicílio do usuário ou, à sua escolha, o do domicílio do fornecedor,
          nos termos do CDC.
        </p>
      </section>

      <section>
        <h4 className="mb-2 text-base font-semibold text-cyan-300">10. Contato</h4>
        <p>
          Dúvidas: <a className="text-cyan-300 underline" href={`mailto:${COMPANY_INFO.email}`}>{COMPANY_INFO.email}</a> • WhatsApp: {COMPANY_INFO.whatsappPhone}.
        </p>
      </section>
    </div>
  );
}
